/*
* @Author: jack
* @Date:   2020-01-08 21:00:00
* @Last Modified by:   jack
* @Last Modified time: 2021-03-30 15:38:55
*/
import request from '@/utils/request'


export function getUserInfo(data) {
  return request({
    url: 'api/acitvity/dati/user/info',
    method: 'post',
    data
  })
}
export function datiQestionInfo(data) {
  return request({
    url: 'api/acitvity/dati/question/info',
    method: 'post',
    data
  })
}

export function datiStore(data) {
  return request({
    url: 'api/acitvity/dati/question/store',
    method: 'post',
    data
  })
}
export function datiShare(data) {
  return request({
    url: 'api/acitvity/dati/question/sharee',
    method: 'post',
    data
  })
}
export function getResultInfo(data) {
  return request({
    url: 'api/acitvity/dati/question/result',
    method: 'post',
    data
  })
}
export function getRank(data) {
  return request({
    url: 'api/acitvity/dati/question/rank',
    method: 'post',
    data
  })
}
export function getRedbagInfo(data) {
  return request({
    url: 'api/acitvity/dati/question/redbag',
    method: 'post',
    data
  })
}
export function sendRedbag(data) {
  return request({
    url: 'api/acitvity/dati/question/send/redbag',
    method: 'post',
    data
  })
}
export function setUserInfo(data) {
  return request({
    url: 'api/acitvity/dati/user/save',
    method: 'post',
    data
  })
}
export function getRedbagCallback(data) {
  return request({
    url: 'api/acitvity/dati/question/callback',
    method: 'post',
    data
  })
}
